import { inject, Injectable } from '@angular/core';
import { GraphqlIndexer } from './providers/graphql.indexer';
import { JsonrpcIndexer } from './providers/jsonrpc.indexer';

@Injectable({
    providedIn: 'root'
})
export class Indexer {

    /**
     * Graphql indexer provider
     */
    graphql_indexer_provider = inject(GraphqlIndexer);

    /**
     * Rpc indexer provider
     */
    jsonrpc_indexer_provider = inject(JsonrpcIndexer);

    /**
     * Read object
     * 
     * @param indexer
     * @param id
     */
    async readObject(indexer: string, id: string): Promise<any> {
        let object = null;

        switch (indexer) {
            case 'graphql':
                object = await this.graphql_indexer_provider.readObject(id);
                break;
            case 'jsonrpc':
                object = await this.jsonrpc_indexer_provider.readObject(id);
                break;
        }

        return object;
    }

    /**
     * Read dynamic field
     * 
     * @param indexer
     * @param id
     * @param value
     */
    async readDynamicField(indexer: string, id: string, type: string, value: string): Promise<any> {
        let field = null;

        switch (indexer) {
            case 'graphql':
                field = await this.graphql_indexer_provider.readDynamicField(id, type, value);
                break;
            case 'jsonrpc':
                field = await this.jsonrpc_indexer_provider.readDynamicField(id, type, value);
                break;
        }

        return field;
    }

    /**
     * Read balance
     * 
     * @param indexer
     * @param id
     * @param signature
     */
    async readBalance(indexer: string, id: string, signature: string): Promise<bigint> {
        let balance: bigint = BigInt(0);

        switch (indexer) {
            case 'graphql':
                balance = await this.graphql_indexer_provider.readBalance(id, signature);
                break;
            case 'jsonrpc':
                balance = await this.jsonrpc_indexer_provider.readBalance(id, signature);
                break;
        }

        return balance;
    }

    /**
     * Read events
     * 
     * @param indexer
     * @param version
     * @param event_type 
     * @param sender
     */
    async readEvents(indexer: string, version: number, event_type: string, sender?: string): Promise<Array<any>> {
        let events: Array<any> = [];

        switch (indexer) {
            case 'graphql':
                events = await this.graphql_indexer_provider.readEvents(version, event_type, sender);
                break;
            case 'jsonrpc':
                events = await this.jsonrpc_indexer_provider.readEvents(version, event_type, sender);
                break;
        }

        return events;
    }
}




